import { forwardRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { LIMITE_CONTEUDO_HTML } from "./htmlMensagem";
import "./mensagemGlobal.css";

const MODULOS = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["clean"],
  ],
};

const FORMATOS = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "align",
];

export const EditorConteudo = forwardRef(({ value, onChange, disabled }, ref) => {
  const tamanho = (value || "").length;

  return (
    <div
      ref={ref}
      className={`editor-mensagem ${disabled ? "editor-mensagem--readonly" : ""}`}
    >
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={MODULOS}
        formats={FORMATOS}
        readOnly={disabled}
        placeholder="Escreva a mensagem. Use a barra para negrito, itálico e listas."
      />
      {!disabled && (
        <div className="editor-mensagem__contador">
          {tamanho} / {LIMITE_CONTEUDO_HTML}
        </div>
      )}
    </div>
  );
});

EditorConteudo.displayName = "EditorConteudo";

